import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "color", "bg", "theme", "title", "svgStyle"];
import React from "react";
import { withTheme } from "styled-components";
import Box from "../Box";
var PlayIcon = withTheme(function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? "18px" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "18px" : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "ctrl" : _ref$color,
      _ref$bg = _ref.bg,
      bg = _ref$bg === void 0 ? "ctrlBg" : _ref$bg,
      theme = _ref.theme,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Icons/Play' : _ref$title,
      svgStyle = _ref.svgStyle,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    mt: "1px"
  }, props), /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 290 290",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: svgStyle
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: theme.colors[bg] || bg,
    d: "M145,285.133971 C221.76555,285.133971 285,221.76555 285,145 C285,68.2344498 221.631579,5 145,5 C68.2344498,5 5,68.2344498 5,145 C5,221.76555 68.2344498,285.133971 145,285.133971 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: theme.colors[color] || color,
    d: "M103.870813,194.167464 L103.870813,96.1004785 C103.870813,89.1339713 112.043062,85.784689 118.339713,89.4019139 L199.92823,137.363636 C205.688995,140.84689 205.822967,149.555024 199.92823,153.038278 L118.339713,200.732057 C111.77512,204.617225 103.870813,201.133971 103.870813,194.167464 Z",
    fillRule: "nonzero"
  }))));
});
export default PlayIcon;